import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import { ExternalLink } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { NotificationBell } from '@/features/notifications/notification-bell'
import { AssistantSheet } from '@/features/assistant/assistant-sheet'
import { env } from '@/lib/env'
import { isDemo } from '@/lib/demo'
import { findNavTitle } from './navigation'

export function AppHeader() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const title = findNavTitle(pathname)

  return (
    <header className="sticky top-0 z-20 flex h-13 shrink-0 items-center gap-2 border-b border-border/70 bg-sheet/85 px-3 backdrop-blur md:rounded-t-xl md:px-4">
      <SidebarTrigger className="text-muted-foreground" />
      {title && (
        <p className="truncate border-l pl-3 text-sm font-medium">{t(title)}</p>
      )}

      <div className="ml-auto flex items-center gap-1">
        {isDemo() && (
          <a href="/__demo/off" className="mr-2 rounded-full bg-window/20 px-2.5 py-0.5 text-xs font-medium text-foreground hover:bg-window/30">
            Demo data
          </a>
        )}
        <AssistantSheet />
        <Button variant="outline" size="sm" asChild>
          <a href={env.cityViewUrl} target="_blank" rel="noopener noreferrer">
            <ExternalLink />
            <span className="hidden sm:inline">{t('layout.header.openCityView')}</span>
          </a>
        </Button>
        <NotificationBell />
      </div>
    </header>
  )
}
